/**
 * Lifecycle of a `Dictation` (Spec § 3.3). The happy path runs
 * `UPLOADED → NORMALIZING → TRANSCRIBING → TRANSCRIBED → SAVED`; `FAILED`
 * (with `failedStep`) sits beside it, and `TRANSCRIBING` is re-entered by a
 * `transcript` regeneration. `SAVED` and `DISCARDED` are terminal.
 */
export var DictationStatus;
(function (DictationStatus) {
    DictationStatus["UPLOADED"] = "UPLOADED";
    DictationStatus["NORMALIZING"] = "NORMALIZING";
    DictationStatus["TRANSCRIBING"] = "TRANSCRIBING";
    DictationStatus["TRANSCRIBED"] = "TRANSCRIBED";
    DictationStatus["SAVED"] = "SAVED";
    DictationStatus["FAILED"] = "FAILED";
    DictationStatus["DISCARDED"] = "DISCARDED";
})(DictationStatus || (DictationStatus = {}));
/** Rule 3.2-2: open = status ∉ {SAVED, DISCARDED}; a `FAILED` dictation is still open. */
export const OPEN_DICTATION_STATUSES = [
    DictationStatus.UPLOADED,
    DictationStatus.NORMALIZING,
    DictationStatus.TRANSCRIBING,
    DictationStatus.TRANSCRIBED,
    DictationStatus.FAILED,
];
export const isOpenDictationStatus = (status) => OPEN_DICTATION_STATUSES.includes(status);
//# sourceMappingURL=dictation-status.enum.js.map